__turbopack_context__.v({
  "message": "cart-bundle-incentive-module__uaafZq__message",
  "root": "cart-bundle-incentive-module__uaafZq__root",
});
